import { useCallback, useState } from 'react';

export const useAccumulatedInferenceIds = () => {
  const [ids, setIds] = useState<string[]>([]);
  const add = useCallback((newIds: string[]) => {
    setIds((prev) => {
      const merged = Array.from(new Set([...prev, ...newIds]));
      return merged.length === prev.length ? prev : merged;
    });
  }, []);
  const clear = useCallback(() => setIds([]), []);
  return { ids, add, clear };
};
